import { Component, inject, ChangeDetectorRef, ElementRef, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { TessContext } from './module/shared/tess-context/tess-context';
import { AppHost } from 'lib-host-interface';
import { ApphostService } from './module/shared/services/app-host.service';
import { LoggingService } from './module/shared/services/logging.service';

@Component({
  selector: 'tess-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent extends TessContext implements OnInit {
  private router = inject(Router);

  hideHeader: boolean;

  constructor(
    appHost: AppHost,
    changeDetectorRef: ChangeDetectorRef,
    elementRef: ElementRef,
    private apphostService: ApphostService,
    loggingService: LoggingService,
  ) {
    super(appHost, changeDetectorRef, elementRef, apphostService, loggingService);

    /**
     * hide the 'My Dashboard' header, for my-account
     */
    this.router.events.pipe(filter((event: any) => event instanceof NavigationEnd)).subscribe((event) => {
      this.loggingService.log(`Navigation to: ${event.urlAfterRedirects}`);
      this.hideHeader = ['/finprogw/my-account', '/workspaces/finprogw/my-account'].includes(event.urlAfterRedirects);
    });
  }

  async ngOnInit() {
    this.loggingService.log('AppComponent: Starting Tess app initialization');
    await this.initiateTessApp();
    this.loggingService.log(`AppComponent: Tess app initialized, user: ${this.apphostService.userInfo?.userId}`);
  }
}
